import { jsx } from 'react/jsx-runtime';
import { getClassNames } from '@websolutespa/bom-core';
import { Action } from '../Action/action.js';

const ActionGroup = props => {
  const {
    item
  } = props;
  const classNames = getClassNames('llm__actions');
  return jsx("div", {
    className: classNames,
    children: item.items.map((item, i) => jsx(Action, Object.assign({}, props, {
      item: item
    }), i))
  });
};

export { ActionGroup };
//# sourceMappingURL=action-group.js.map
